// extracted by mini-css-extract-plugin
module.exports = {"stars":"star_stars__2IC0d"};